export const SITE_NAME = process.env.VUE_APP_SITE_NAME || '方舟天下'

export const DEFAULT_SEO = {
  title: SITE_NAME,
  keywords: '',
  description: ''
}

export const ROUTE_SEO_MAP = {
  index: {
    title: SITE_NAME
  },
  immigration: {
    title: '移民项目'
  },
  immigrationDetail: {
    title: '移民项目详情'
  },
  Case: {
    title: '成功案例'
  },
  CaseDetail: {
    title: '案例详情'
  },
  newsCenter: {
    title: '新闻中心'
  },
  newsDetail: {
    title: '新闻详情'
  },
  contact: {
    title: '联系我们'
  },
  assessPage: {
    title: '免费评估'
  }
}
